var __jsx = React.createElement;
import stl from './Alert.module.css';
import React from "react";
import { CDN_LINK } from "@globalConfig";
var Alert = function Alert(_ref) {
  var message = _ref.message,
    variant = _ref.variant,
    note = _ref.note;
  return /*#__PURE__*/React.createElement("div", {
    className: [stl.alert, stl[variant]].join(" ")
  }, /*#__PURE__*/React.createElement("span", {
    className: stl.alertIcon
  }, /*#__PURE__*/React.createElement("img", {
    width: 16,
    height: 16,
    src: CDN_LINK + "/assets/images/tracking-details/".concat(variant, ".svg"),
    alt: variant
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.messageBox
  }, /*#__PURE__*/React.createElement("span", {
    className: stl.message
  }, message), note && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: stl.note
  }, note))));
};
export default Alert;